import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { environment } from 'src/environments/environment';
import { PatientAccessUpdateDataResponse } from '../../responses/medical-record/patient-access-update-data.response';
import { UpdatePatientAddressRequest } from '../../requests/medical-record/update-patient-address-request';

@Injectable({
  providedIn: 'root'
})
export class PatientAccessUpdateDataService extends CommonService {

  constructor(private httpClient: HttpClient) { super(); }

  public getPatientByGuid(guid: string): Observable<PatientAccessUpdateDataResponse> {
    let uri = `PatientAccessUpdateData/${guid}`

    return this.httpClient.get<PatientAccessUpdateDataResponse>(environment.urlApiMedicalRecord + uri, this.addHeaderHash())
      .pipe(
        catchError(this.handleError)
      )
  }

  public putPatient(idPatient: number, request: UpdatePatientAddressRequest): Observable<PatientAccessUpdateDataResponse> {
    let uri = `PatientAccessUpdateData/${idPatient}`

    return this.httpClient.put<PatientAccessUpdateDataResponse>(environment.urlApiMedicalRecord + uri, request, this.addHeaderHash())
      .pipe(
        catchError(this.handleError)
      )
  }
}
